import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { LAYOUT } from "../constants";
import { type ScoreChange } from "../types";
import { ScoreLineItem } from "./ScoreLineItem";

interface ScoreLineItemsContainerProps {
  /**
   * Starting score to display as first line item
   */
  startScore: number;
  /**
   * Score changes to display as line items
   */
  scoreChanges: ScoreChange[];
  /**
   * Number of score change line items that should be visible (0 = none visible)
   */
  visibleLineItemCount: number;
}

export function ScoreLineItemsContainer(props: ScoreLineItemsContainerProps) {
  const { startScore, scoreChanges, visibleLineItemCount } = props;

  return (
    <Stack
      spacing={4}
      sx={{
        width: "100%",
        maxWidth: LAYOUT.CONTENT_MAX_WIDTH,
        paddingX: 5,
      }}
    >
      {/* Starting score - always visible */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Text variant="body2">Starting Clipboard Score</Text>
        <Text variant="body1">{startScore}</Text>
      </Stack>

      {/* Score change line items - visibility controlled by animation */}
      {scoreChanges.map((change, index) => (
        <ScoreLineItem
          key={change.label}
          label={change.label}
          value={change.value}
          color={change.color}
          isVisible={index < visibleLineItemCount}
        />
      ))}
    </Stack>
  );
}
